export const GET_GL_LAB_ASSIGNMENT_AND_SUBMISSION_DATA =
  'GET_GL_LAB_ASSIGNMENT_AND_SUBMISSION_DATA'
export const GET_GL_LAB_ASSIGNMENT_AND_SUBMISSION_DATA_SUCCESS =
  'GET_GL_LAB_ASSIGNMENT_AND_SUBMISSION_DATA_SUCCESS'
export const GET_GL_LAB_ASSIGNMENT_AND_SUBMISSION_DATA_FAILURE =
  'GET_GL_LAB_ASSIGNMENT_AND_SUBMISSION_DATA_FAILURE'
export const GET_GL_LAB_ASSIGNMENT_AND_SUBMISSION_DATA_CANCEL =
  'GET_GL_LAB_ASSIGNMENT_AND_SUBMISSION_DATA_CANCEL'
